import { format } from "date-fns";

export const TIPI = [
  { value: "riunione", label: "Riunione", color: "#0A1128" },
  { value: "shooting", label: "Shooting", color: "#E8173A" },
  { value: "call", label: "Call", color: "#2B9BE8" },
  { value: "consegna", label: "Consegna", color: "#F59E0B" },
  { value: "altro", label: "Altro", color: "#64748B" },
];
export const tipoOf = (v) => TIPI.find((t) => t.value === v) || TIPI[4];

export const STATO_INVITO = {
  non_inviato: { label: "Invito non inviato", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  inviato: { label: "Invito inviato", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  da_aggiornare: { label: "Aggiornamento da inviare", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  annullato: { label: "Annullamento inviato", cls: "bg-red-50 text-[#C8102E] border-red-200" },
};

export const PALETTE = ["#0A1128", "#E8173A", "#2B9BE8", "#C2410C", "#2563EB", "#9D174D", "#4D7C0F", "#7C2D12", "#0891B2", "#A16207"];

export const colorIndex = (ids, id) => {
  const i = ids.indexOf(id);
  return i < 0 ? "#94A3B8" : PALETTE[i % PALETTE.length];
};

export const toLocalInput = (d) => format(new Date(d), "yyyy-MM-dd'T'HH:mm");
export const fromLocalInput = (v) => new Date(v).toISOString();

export const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const lastRecipients = (a) => {
  const ok = (a?.inviti || []).filter((i) => i.status === "inviato" && i.tipo !== "annullamento");
  return ok.length ? ok[ok.length - 1].to : a?.client_email ? [a.client_email] : [];
};

export const hasSentInvite = (a) => ["inviato", "da_aggiornare"].includes(a?.stato_invito);
